import { render, staticRenderFns } from "./goodsSearch.vue?vue&type=template&id=3d62eefe&scoped=true"
import script from "./goodsSearch.vue?vue&type=script&lang=js"
export * from "./goodsSearch.vue?vue&type=script&lang=js"
import style0 from "./goodsSearch.vue?vue&type=style&index=0&id=3d62eefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d62eefe",
  null
  
)

export default component.exports